// @flow
import { connect } from 'react-redux';

import { compose } from 'redux';

import {
  setBackground,
  toggleAircrafts,
  toggleAirports,
  toggleExtrusion,
  toggleStyleCategory,
} from 'actions/map';
import MapLayerDrawer from './MapLayerDrawer';
import withCurrentLocation from '../withCurrentLocation';

const mapStateToProps = ({
  mapLayerDrawer,
  browser,
  map,
  flags: { hasSubscription },
}) => ({
  mapLayerDrawer,
  browser,
  map,
  hasSubscription,
});

const mapDispatchToProps = {
  setBackground,
  toggleExtrusion,
  toggleStyleCategory,
  toggleAirports,
  toggleAircrafts,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withCurrentLocation
)(MapLayerDrawer);



// WEBPACK FOOTER //
// ./components/MapLayerDrawer/index.js